<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  app: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(['edit', 'delete']);

const { t } = useI18n();

// NOTICE: KAPTION-INTEGRATION
const placementLabel = placement => {
  const labels = {
    main: t('INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.PLACEMENT_MAIN'),
    sidebar: t('INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.PLACEMENT_SIDEBAR'),
    full_screen: t(
      'INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.PLACEMENT_FULL_SCREEN'
    ),
  };
  return (
    labels[placement] ||
    t('INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.PLACEMENT_MAIN')
  );
};
</script>

<template>
  <tr class="max-w-full py-1">
    <td
      class="py-4 ltr:pr-4 rtl:pl-4 text-sm w-40 max-w-[10rem] truncate"
      :title="app.title"
    >
      {{ app.title }}
    </td>
    <td
      class="max-w-lg py-4 ltr:pr-4 rtl:pl-4 text-sm truncate"
      :title="app.content[0].url"
    >
      {{ app.content[0].url }}
    </td>
    <!-- NOTICE: KAPTION-INTEGRATION -->
    <td class="py-4 ltr:pr-4 rtl:pl-4 text-sm">
      <span
        class="inline-flex items-center rounded-full bg-n-secondary px-3 py-1 text-xs font-medium"
      >
        {{ placementLabel(app.placement) }}
      </span>
      <span
        v-if="app.is_full_screen"
        class="inline-flex items-center rounded-full bg-n-secondary px-3 py-1 text-xs font-medium ml-1"
      >
        {{ placementLabel('full_screen') }}
      </span>
    </td>
    <td class="flex gap-1 py-4 ltr:pr-4 rtl:pl-4 text-sm sm:pr-0 justify-end">
      <Button
        v-tooltip.top="
          $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.EDIT_TOOLTIP')
        "
        icon="i-lucide-pen"
        slate
        xs
        faded
        @click="$emit('edit', app)"
      />
      <Button
        v-tooltip.top="
          $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.LIST.DELETE_TOOLTIP')
        "
        icon="i-lucide-trash-2"
        xs
        ruby
        faded
        @click="$emit('delete', app)"
      />
    </td>
  </tr>
</template>
